import store from '../'
import axios from 'axios'
import {router} from '../../router/router.js'
import {SERVER_PATH} from '../../config'
import {functions} from '../../functions'
import { EventBus } from '../../eventBus'
const state = {
    menuOptions: {
        cpu: {
            type: 'cpu',
            name: "CPU",
            url: 'cpu',
            item: {
                type: 'cpu',
                id: 1,
                contents: null,
            },
        },
        graphics: {
            type: 'gpu',
            name: "Graphics",
            url: 'gpu',
            item: {
                type: 'gpu',
                id: 5,
                contents: null,
            },
        },
        ram: {
            type: 'ram',
            name: "RAM",
            url: 'ram',
            item: {
                type: 'ram',
                id: 3,
                contents: null,
            },
        },
        storage: {
            type: 'storage',
            name: "Storage",
            url: 'storage',
            item: {
                type: 'storage',
                id: 4,
                contents: null,
            },
        },
        case: {
            type: 'case',
            name: "Case",
            url: 'case',
            item: {
                type: 'case',
                id: 7,
                contents: null,
            },
        },
        motherboard: {
            type: 'motherboard',
            name: "Motherboard",
            url: 'motherboard',
            item: {
                type: 'motherboard',
                id: 2,
                contents: null,
            },
        },
        psu: {
            type: 'psu',
            name: "Power Supply",
            url: 'psu',
            item: {
                type: 'psu',
                id: 6,
                contents: null,
            },
        },
        // accessories: {
        //     type: 'accessories',
        //     name: "Accessories",
        //     url: 'accessories',
        //     item: {
        //         type: 'accessories',
        //         id: 8,
        //         contents: null,
        //     },
        // },
    },
    build:[
        {   id: 1,
            type: "cpu",
            contents: null
        },
        {   id: 2,
            type: "motherboard",
            contents: null
        },
        {   id: 3,
            type: "ram",
            contents: null
        },
        {   id: 4,
            type: "storage",
            contents: null
        },
        {   id:5,
            type: "gpu",
            contents: null
        },
        {   id: 6,
            type: "psu",
            contents: null
        },
        {   id: 7,
            type: "case",
            contents: null
        },
        // {   id: 8,
        //     type: "accessories",
        //     contents: null
        // },
    ],
    compatLib: {},
    compatTable: {},
    stateCompatTable: {},
    buildRaw : {
        processor_id:   '',
        motherboard_id: '',
        ram_id:         [],
        storage_id:     [],
        graphics_id:    [],
        psu_id:         '',
        case_id:        '',
    },
    buildTDP: 0,
    totalCost: 0,
    processing: false,
    recentBuilds: [],
    buildsLoaded: false,
    compatibleMode: true,
    buildStatus:    'ok',
    warningsTable: {},
    warnings: [],
};
const getters = {
    getWarnings:                (state) => state.warnings,
    getBuidStatus:              (state) => state.buildStatus,
    getCompatibleMode:          (state) => state.compatibleMode,
    getCompatLib:               (state) => state.compatLib,
    getBuildTDP:                (state) => state.buildTDP,
    getStateCompatTable:        (state) => state.stateCompatTable,
    getCompatTable:             (state) => state.compatTable,
    ifProcessing:               (state) => state.processing,
    allMenuOptions:             (state) => state.menuOptions,
    getBuild:                   (state) => state.build,
    getBuildRaw:                (state) => state.buildRaw,
    getTotalCost:               (state) => state.totalCost,
    getRecentBuilds:            (state) => state.recentBuilds,
    getBuildsLoaded:            (state) => state.buildsLoaded
};
const actions = {
    compatMode({commit}, bool){
        commit('SET_COMPAT_MODE', bool)
    },
    updateBuildStatus({commit}, status){
        commit('UPDATE_BUILD_STATUS', status)
    },
    async fetchRecentBuilds ({commit, state}, {from, limit}){
        commit('BUILDS_LOADED', false)
        if(!from && limit && limit >0){
            const builds = await axios({
                method: 'GET',
                url: `${SERVER_PATH}builds/builds?limit=${limit}`,
            }).then((response) => {
                commit('RECORD_FETCHED_BUILDS', response.data.Builds)
                commit('BUILDS_LOADED', true)
                console.log('fetched recent builds ', state.recentBuilds, ' builds Loaded: ', state.buildsLoaded)
            }).catch((err) => {
                commit('BUILDS_LOADED', false)
                console.log(err)
            })
        }
    },
    async isCompatible      ({commit, state }, {item, withType, option, forState, forLib}){
        // If Item exists in build
        var theTable = {}
        var warningsTable = {}
        var warnings = []
        var recordCompat = 'RECORD_COMPAT'
        if(forState == true){
            recordCompat = 'RECORD_STATE_COMPAT'
        }
        if(forLib == true){
            recordCompat = "RECORD_LIB_COMPAT"
        }
        var buildItem
        if(withType == 'general'){
            buildItem = {
                item: {
                    contents:{
                        power: state.buildTDP
                    }
                }
            }
        }
        else {
            buildItem = state.menuOptions[withType]
        }
        if(buildItem && buildItem.item.contents !== null && item){
            // Checking compatibility with received item
            if(!item.compat && item.item && item.item.contents) {
                var tempItem = item.item.contents
                item = tempItem
            }
            if(item.compat){
                // Which type is being viewed by user               
                switch (item.type){                                 // <<<<<<<<<< THIS
                    // Processor        Compatibility Check
                    case 'cpu':
                        // Item which is selected in user's build 
                        switch (withType){                          // <<<<<<<<<< WITH THIS ITEM IN BUILD
                            case 'motherboard':
                                switch (option){
                                    case 'socket':
                                        if (buildItem){
                                            let buildItemSocket = buildItem.item.contents.compat.socket
                                            let itemSocket = item.compat.socket
                                            if(buildItemSocket.includes(itemSocket) || itemSocket.includes(buildItemSocket)){
                                                commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: true, message: ''})
                                            }
                                            else {
                                                commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: false, message: 'motherboard socket ' + buildItem.item.contents.compat.socket + ' is incompatible with socket' + item.compat.socket + 'on the cpu'})
                                            }
                                        }
                                    break
                                    case 'ram_speed':
                                        if (buildItem){
                                            if(parseInt(buildItem.item.contents.compat.ram_speed) == parseInt(item.compat.ram_speed)){
                                                commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: true, message: ''})
                                            }
                                            else if(parseInt(buildItem.item.contents.compat.ram_speed) < parseInt(item.compat.ram_speed) || parseInt(buildItem.item.contents.compat.ram_speed) > parseInt(item.compat.ram_speed)){
                                                commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: true, warning: true, message: `RAM SPEED MISMATCH \n, your computer will run at ${parseInt(item.compat.ram_speed) < parseInt(buildItem.item.contents.compat.ram_speed) ? parseInt(item.compat.ram_speed) : parseInt(buildItem.item.contents.compat.ram_speed)} Mhz`})
                                            }
                                            // else {
                                            //     commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: false, message: 'cpu ram speed ' + buildItem.item.contents.compat.ram_speed + ' is incompatible with' + item.compat.ram_speed + 'on the motherboard'})
                                            // }
                                        }
                                        break
                                    case 'ram_type':
                                        if (buildItem){
                                            if(buildItem.item.contents.compat.ram.includes(item.compat.ram) || item.compat.ram.includes(buildItem.item.contents.compat.ram)){
                                                commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: true, message: ''})
                                            }
                                            else {
                                                commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: false, message: 'cpu ram ' + buildItem.item.contents.compat.ram + ' is incompatible with' + item.compat.ram + 'on the motherboard'})
                                            }
                                        }
                                        break
                                    case 'processor_generation':
                                        if (buildItem){
                                            if(buildItem.item.contents.compat.cpu_brand.toLowerCase() == item.compat.brand.toLowerCase()){
                                                var procGenCpu = parseInt(buildItem.item.contents.compat.processor_generation)
                                                var procGenMb = item.compat.processor_generation.split(/[-,_ ]+/)
                                                var value = false
                                                for (var q = 0; q < procGenMb.length; q++){
                                                    if(procGenCpu >= parseInt(procGenMb[q])){
                                                        value = true
                                                    }
                                                }
                                                commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: value, message: ''})
                                            }
                                            else {
                                                commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: false, message: 'cpu ram speed ' + buildItem.item.contents.compat.ram_speed + ' is incompatible with' + item.compat.ram_speed + 'on the motherboard'})
                                            }
                                        }
                                        break
                                    }
                                break
                            case 'ram':
                                switch (option){
                                    case 'ram_type':
                                        if (buildItem && buildItem.item.contents){
                                            if(item.compat.ram.includes(buildItem.item.contents[0].compat.ram_type)){
                                                commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: true, message: ''})
                                            }
                                            else {
                                                commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: false, message: 'cpu ram ' + buildItem.item.contents[0].compat.ram_type + ' is incompatible with' + item.compat.ram + 'on the motherboard'})
                                            }
                                        }
                                        break
                                    case 'ram_speed':
                                        if (buildItem){
                                            if(parseInt(buildItem.item.contents[0].compat.ram_speed) == parseInt(item.compat.ram_speed)){
                                                commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: true, message: ''})
                                            }
                                            else if(parseInt(buildItem.item.contents[0].compat.ram_speed) < parseInt(item.compat.ram_speed) || parseInt(buildItem.item.contents[0].compat.ram_speed) > parseInt(item.compat.ram_speed)){
                                                commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: true, warning: true, message: `RAM SPEED MISMATCH \n your computer will run at ${parseInt(item.compat.ram_speed) < parseInt(buildItem.item.contents[0].compat.ram_speed) ? parseInt(item.compat.ram_speed) : parseInt(buildItem.item.contents[0].compat.ram_speed)} Mhz`})
                                            }
                                            // else {
                                            //     commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: false, message: 'cpu ram ' + buildItem.item.contents[0].compat.ram_type + ' is incompatible with' + item.compat.ram + 'on the motherboard'})
                                            // }
                                        }
                                        break
                                    case 'max_memory':
                                        if (buildItem){
                                            var totalRam = 0
                                            if(buildItem.item.contents && buildItem.item.contents.length >0){
                                                for(var j = 0; j < buildItem.item.contents.length; j++){
                                                    totalRam += parseInt(buildItem.item.contents[j].compat.capacity)
                                                }
                                                if(totalRam <= parseInt(item.specs.Max_Memory_Size)){
                                                    commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: true, message: ''})
                                                }
                                            }
                                            else {
                                                commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: false, message: 'total ram  ' + totalRam + 'GB is more than ' + item.specs.Max_Memory_Size + ' maximum ram size on the motherboard'})
                                            }
                                        }
                                        break
                                }
                                break
                        }    
                        break
                    // Motherboard      Compatibility Check
                    case 'motherboard':
                        switch (withType){                          // <<<<<<<<<< WITH THIS
                            case 'cpu':
                                switch (option){
                                    case 'socket':
                                        if (buildItem){
                                            if(buildItem.item.contents.compat.socket.includes(item.compat.socket) || item.compat.socket.includes(buildItem.item.contents.compat.socket)){
                                                commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: true, message: ''})
                                            }
                                            else {
                                                commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: false, message: 'cpu socket ' + buildItem.item.contents.compat.socket + ' is incompatible with socket' + item.compat.socket + 'on the motherboard'})
                                            }
                                        }
                                        break
                                    case 'ram_type':
                                        if (buildItem){
                                            if(buildItem.item.contents.compat.ram.includes(item.compat.ram) || item.compat.ram.includes(buildItem.item.contents.compat.ram)){
                                                commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: true, message: ''})
                                            }
                                            else {
                                                commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: false, message: 'cpu ram ' + buildItem.item.contents.compat.ram + ' is incompatible with' + item.compat.ram + 'on the motherboard'})
                                            }
                                        }
                                        break
                                    case 'ram_speed':
                                        if (buildItem){
                                            if(parseInt(buildItem.item.contents.compat.ram_speed) == parseInt(item.compat.ram_speed)){
                                                commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: true, message: ''})
                                            }
                                            else if(parseInt(buildItem.item.contents.compat.ram_speed) < parseInt(item.compat.ram_speed) || parseInt(buildItem.item.contents.compat.ram_speed) > parseInt(item.compat.ram_speed)){
                                                if(state.menuOptions.ram.item.contents){
                                                    if((parseInt(state.menuOptions.ram.item.contents[0].compat.ram_speed) < parseInt(buildItem.item.contents.compat.ram_speed))
                                                    && (parseInt(state.menuOptions.ram.item.contents[0].compat.ram_speed) < parseInt(item.compat.ram_speed))
                                                    ){
                                                        commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: true, warning: true, message: `RAM SPEED MISMATCH \n your computer will run at ${parseInt(state.menuOptions.ram.item.contents[0].compat.ram_speed)} Mhz`})
                                                    }
                                                }
                                                else{
                                                    commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: true, warning: true, message: `RAM SPEED MISMATCH \n your computer will run at ${parseInt(item.compat.ram_speed) < parseInt(buildItem.item.contents.compat.ram_speed) ? parseInt(item.compat.ram_speed) : parseInt(buildItem.item.contents.compat.ram_speed)} Mhz`})
                                                }
                                            }
                                            // else {
                                            //     commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: false, message: 'cpu ram speed ' + buildItem.item.contents.compat.ram_speed + ' is incompatible with' + item.compat.ram_speed + 'on the motherboard'})
                                            // }
                                        }
                                        break
                                    case 'processor_generation':
                                        if (buildItem){
                                            if(buildItem.item.contents.compat.brand.toLowerCase() == item.compat.cpu_brand.toLowerCase()){
                                                var procGenCpu = parseInt(buildItem.item.contents.compat.processor_generation)
                                                var procGenMb = item.compat.processor_generation.split(/[-,_ ]+/)
                                                var value = false
                                                for (var q = 0; q < procGenMb.length; q++){
                                                    if(procGenCpu <= parseInt(procGenMb[q])){
                                                        console.log("procGenCpu is less than ", parseInt(procGenMb[q]))
                                                        value = true
                                                    }
                                                }
                                                commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: value, message: ''})
                                            }
                                            else {
                                                commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: false, message: 'cpu ram speed ' + buildItem.item.contents.compat.ram_speed + ' is incompatible with' + item.compat.ram_speed + 'on the motherboard'})
                                            }
                                        }
                                        break
                                }
                                break
                            case 'ram':
                                switch (option){
                                    case 'ram_type':
                                        if (buildItem){
                                            if(buildItem.item.contents[0].compat.ram_type.includes(item.compat.ram) || item.compat.ram.includes(buildItem.item.contents[0].compat.ram_type)){
                                                commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: true, message: ''})
                                            }
                                            else {
                                                commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: false, message: 'cpu ram ' + buildItem.item.contents[0].compat.ram_type + ' is incompatible with' + item.compat.ram + 'on the motherboard'})
                                            }
                                        }
                                        break
                                    case 'ram_speed':
                                        if (buildItem){
                                            if(parseInt(buildItem.item.contents[0].compat.ram_speed) == parseInt(item.compat.ram_speed)){
                                                commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: true, message: ''})
                                            }
                                            else if(parseInt(buildItem.item.contents[0].compat.ram_speed) < parseInt(item.compat.ram_speed) || parseInt(buildItem.item.contents[0].compat.ram_speed) > parseInt(item.compat.ram_speed)){
                                                if(state.menuOptions.cpu.item.contents){
                                                    if((parseInt(state.menuOptions.cpu.item.contents.compat.ram_speed) < parseInt(buildItem.item.contents[0] ? buildItem.item.contents[0].compat.ram_speed : buildItem.item.contents.compat.ram_speed))
                                                    && (parseInt(state.menuOptions.cpu.item.contents.compat.ram_speed) < parseInt(item.compat ? item.compat.ram_speed : item[0].compat.ram_speed))
                                                    ){
                                                        commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: true, warning: true, message: `RAM SPEED MISMATCH \n your computer will run at ${parseInt(state.menuOptions.cpu.item.contents.compat.ram_speed)} Mhz`})
                                                    }
                                                }
                                                else{
                                                    commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: true, warning: true, message: `RAM SPEED MISMATCH \n your computer will run at ${parseInt(item.compat.ram_speed) < parseInt(buildItem.item.contents[0].compat.ram_speed) ? parseInt(item.compat.ram_speed) : parseInt(buildItem.item.contents[0].compat.ram_speed)} Mhz`})
                                                }
                                            }
                                            // else {
                                            //     commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: false, message: 'cpu ram ' + buildItem.item.contents[0].compat.ram_type + ' is incompatible with' + item.compat.ram + 'on the motherboard'})
                                            // }
                                        }
                                        break
                                    case 'number_of_items':
                                        if (buildItem){
                                            var totalSticks = 0
                                            if(buildItem.item.contents && buildItem.item.contents.length >0){
                                                for(var j = 0; j < buildItem.item.contents.length; j++){
                                                    totalSticks += parseInt(buildItem.item.contents[j].compat.number_of_items)
                                                }
                                            }
                                            if(totalSticks <= parseInt(item.compat.ram_slots)){
                                                commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: true, message: ''})
                                            }
                                            else {
                                                commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: false, message: 'number of ram sticks ' + totalSticks + ' is more than ' + item.compat.ram_slots + ' slots on the motherboard'})
                                            }
                                        }
                                        break
                                    case 'max_memory':
                                        if (buildItem){
                                            var totalRam = 0
                                            if(buildItem.item.contents && buildItem.item.contents.length >0){
                                                for(var j = 0; j < buildItem.item.contents.length; j++){
                                                    totalRam += parseInt(buildItem.item.contents[j].compat.capacity)
                                                }
                                            }
                                            if(totalRam <= parseInt(item.specs.Max_Memory_Size)){
                                                commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: true, message: ''})
                                            }
                                            else {
                                                commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: false, message: 'total ram  ' + totalRam + 'GB is more than ' + item.specs.Max_Memory_Size + ' maximum ram size on the motherboard'})
                                            }
                                        }
                                        break
                                }
                                break
                            case 'psu':
                                switch(option){
                                    case 'form_factor':
                                        var itemCompat      = item.compat.form_factor;
                                        var buildItemCompat = buildItem.item.contents.compat['form_factor'];
                                        if(itemCompat.toLowerCase().split('').filter((item) => item !== ' ' && item !== '-').join('').includes(buildItemCompat.toLowerCase())){
                                            commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: 'form_factor', value: true, message: ''})
                                        }
                                        else if (itemCompat !== buildItemCompat){
                                            commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: 'form_factor', value: false, message: itemCompat +' psu does not fit into your ' + buildItemCompat + ' build'})
                                        }
                                }
                                break
                            case 'case':
                                switch(option){
                                    case 'form_factor':
                                        var itemCompat      = item.compat.form_factor;
                                        var buildItemCompat = buildItem.item.contents.compat['form_factor'];
                                        if(itemCompat == buildItemCompat){
                                            commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: 'form_factor', value: true, message: ''})
                                        }
                                        else if(
                                            (itemCompat.toLowerCase().split('').filter((item) => item !== ' ' && item !=='-').join('') == 'atx'
                                            && buildItemCompat.toLowerCase().split('').filter((item) => item !== ' ' && item !=='-').join('') == 'microatx')
                                            || 
                                            (itemCompat.toLowerCase().split('').filter((item) => item !== ' ' && item !=='-').join('') == 'atx'
                                            && buildItemCompat.toLowerCase().split('').filter((item) => item !== ' ' && item !=='-').join('') == 'miniitx')
                                            || (itemCompat.toLowerCase().split('').filter((item) => item !== ' ' && item !=='-').join('') == 'atx'
                                            && buildItemCompat.toLowerCase().split('').filter((item) => item !== ' ' && item !=='-').join('') == 'nanoitx')
                                            || (itemCompat.toLowerCase().split('').filter((item) => item !== ' ' && item !=='-').join('') == 'microatx'
                                            && buildItemCompat.toLowerCase().split('').filter((item) => item !== ' ' && item !=='-').join('') == 'miniitx')
                                            || (itemCompat.toLowerCase().split('').filter((item) => item !== ' ' && item !=='-').join('') == 'miniatx'
                                            && buildItemCompat.toLowerCase().split('').filter((item) => item !== ' ' && item !=='-').join('') == 'microatx')
                                        ){
                                                commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: false, message: 'Your ' + buildItemCompat + '  case is too small for this motherboard ' + itemCompat + ' size'})
                                        }
                                        else if(
                                            (itemCompat.toLowerCase().split('').filter((item) => item !== ' ' && item !=='-').join('') == 'microatx'
                                            && buildItemCompat.toLowerCase().split('').filter((item) => item !== ' ' && item !=='-').join('') == 'atx')
                                            || 
                                            (itemCompat.toLowerCase().split('').filter((item) => item !== ' ' && item !=='-').join('') == 'miniitx'
                                            && buildItemCompat.toLowerCase().split('').filter((item) => item !== ' ' && item !=='-').join('') == 'atx')

                                            || (itemCompat.toLowerCase().split('').filter((item) => item !== ' ' && item !=='-').join('') == 'nanoitx'
                                            && buildItemCompat.toLowerCase().split('').filter((item) => item !== ' ' && item !=='-').join('') == 'atx')

                                            || (itemCompat.toLowerCase().split('').filter((item) => item !== ' ' && item !=='-').join('') == 'miniitx'
                                            && buildItemCompat.toLowerCase().split('').filter((item) => item !== ' ' && item !=='-').join('') == 'microatx')

                                            || (itemCompat.toLowerCase().split('').filter((item) => item !== ' ' && item !=='-').join('') == 'nanoitx'
                                            && buildItemCompat.toLowerCase().split('').filter((item) => item !== ' ' && item !=='-').join('') == 'microatx')
                                            || (itemCompat.toLowerCase().split('').filter((item) => item !== ' ' && item !=='-').join('') == 'nanoitx'
                                            && buildItemCompat.toLowerCase().split('').filter((item) => item !== ' ' && item !=='-').join('') == 'miniitx')
                                        ){
                                                commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: true, warning: true, message: 'Your '+ buildItemCompat  +' case is bigger than ' + itemCompat + ' motherboard'})
                                        }
                                        else if (itemCompat !== buildItemCompat){
                                            commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: 'form_factor', value: false, message: itemCompat +' case does not fit into your ' + buildItemCompat + ' build'})
                                        }
                                }
                                break
                        }    
                        break
                    // RAM              Compatibility Check
                    case 'ram':
                        switch (withType){                          // <<<<<<<<<< WITH THIS
                            case 'cpu':
                                switch (option){
                                    case 'ram_type':
                                        if (buildItem){
                                            if(buildItem.item.contents.compat.ram.includes(item.compat.ram_type) || item.compat.ram_type.includes(buildItem.item.contents.compat.ram)){
                                                commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: true, message: ''})
                                            }
                                            else {
                                                commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: false, message: 'cpu ram ' + buildItem.item.contents.compat.ram + ' is incompatible with ' + item.compat.ram_type + ' ram'})
                                            }
                                        }
                                        break
                                    case 'ram_speed':
                                            if (buildItem){
                                                if(parseInt(buildItem.item.contents[0] ? buildItem.item.contents[0].compat.ram_speed : buildItem.item.contents.compat.ram_speed) == parseInt(item.compat ? item.compat.ram_speed : item[0].compat.ram_speed)){
                                                    commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: true, message: ''})
                                                }
                                                else if(parseInt(buildItem.item.contents[0] ? buildItem.item.contents[0].compat.ram_speed : buildItem.item.contents.compat.ram_speed) < parseInt(item.compat ? item.compat.ram_speed : item[0].compat.ram_speed) || parseInt(buildItem.item.contents[0] ? buildItem.item.contents[0].compat.ram_speed : buildItem.item.contents.compat.ram_speed) > parseInt(item.compat ? item.compat.ram_speed : item[0].compat.ram_speed)){
                                                    if(state.menuOptions.motherboard.item.contents){
                                                        if((parseInt(state.menuOptions.motherboard.item.contents.compat.ram_speed) < parseInt(buildItem.item.contents[0] ? buildItem.item.contents[0].compat.ram_speed : buildItem.item.contents.compat.ram_speed))
                                                        && (parseInt(state.menuOptions.motherboard.item.contents.compat.ram_speed) < parseInt(item.compat ? item.compat.ram_speed : item[0].compat.ram_speed))
                                                        ){
                                                            commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: true, warning: true, message: `RAM SPEED MISMATCH \n your computer will run at ${parseInt(state.menuOptions.motherboard.item.contents.compat.ram_speed)} Mhz`})
                                                        }
                                                    }
                                                    else{
                                                        commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: true, warning: true, message: `RAM SPEED MISMATCH \n your computer will run at ${parseInt(item.compat.ram_speed) < parseInt(buildItem.item.contents.compat.ram_speed) ? parseInt(item.compat.ram_speed) : parseInt(buildItem.item.contents.compat.ram_speed)} Mhz`})
                                                    }
                                                }
                                                // else {
                                                //     commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: false, message: 'cpu ram ' + buildItem.item.contents.compat.ram_type + ' is incompatible with' + item ? item.compat.ram_speed : item[0].compat.ram_speed + 'on the motherboard'})
                                                // }
                                            }
                                            break
                                    case 'max_memory':
                                            if (state.menuOptions.ram.item.contents && buildItem){
                                                var totalRam = 0
                                                if(state.menuOptions.ram.item.contents && state.menuOptions.ram.item.contents.length >0){
                                                    for(var j = 0; j < state.menuOptions.ram.item.contents.length; j++){
                                                        totalRam += parseInt(state.menuOptions.ram.item.contents[j].compat.capacity)
                                                    }
                                                }
                                                if(totalRam <= parseInt(buildItem.item.contents.specs.Max_Memory_Size)){
                                                    commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: true, message: ''})
                                                }
                                                else if(totalRam > parseInt(buildItem.item.contents.specs.Max_Memory_Size)){
                                                    commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: false, message: 'total ram  ' + totalRam + 'GB is more than ' + buildItem.item.contents.specs.Max_Memory_Size + ' maximum ram size on the cpu'})
                                                }
                                            }
                                        break
                                }
                                break
                            case 'motherboard':
                                switch (option){
                                    case 'ram_type':
                                        if (buildItem){
                                            if(item.compat.ram_type.includes(buildItem.item.contents.compat.ram)){
                                                commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: true, message: ''})
                                            }
                                            else {
                                                commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: false, message: 'ram ' + buildItem.item.contents.compat.ram_type + ' is incompatible with ' + item.compat.ram + ' motherboard ram'})
                                            }
                                        }
                                    break
                                    case 'max_memory':
                                        if (state.menuOptions.ram.item.contents && buildItem){
                                            var totalRam = 0
                                            if(state.menuOptions.ram.item.contents && state.menuOptions.ram.item.contents.length >0){
                                                for(var j = 0; j < state.menuOptions.ram.item.contents.length; j++){
                                                    totalRam += parseInt(state.menuOptions.ram.item.contents[j].compat.capacity)
                                                }
                                            }
                                            if(totalRam <= parseInt(buildItem.item.contents.specs.Max_Memory_Size)){
                                                commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: true, message: ''})
                                            }
                                            else {
                                                commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: false, message: 'total ram  ' + totalRam + 'GB is more than ' + 'maximum ram size on the motherboard'})
                                            }
                                        }
                                        break
                                    case 'ram_speed':
                                        if (buildItem){
                                            if(parseInt(buildItem.item.contents.compat.ram_speed) == parseInt(item.compat.ram_speed)){
                                                commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: true, message: ''})
                                            }
                                            else if(parseInt(buildItem.item.contents.compat.ram_speed) < parseInt(item.compat.ram_speed) || parseInt(buildItem.item.contents.compat.ram_speed) > parseInt(item.compat.ram_speed)){
                                                if(state.menuOptions.cpu.item.contents){
                                                    if((parseInt(state.menuOptions.cpu.item.contents.compat.ram_speed) < parseInt(buildItem.item.contents.compat.ram_speed))
                                                    && (parseInt(state.menuOptions.cpu.item.contents.compat.ram_speed) < parseInt(item.compat.ram_speed))
                                                    ){
                                                        commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: true, warning: true, message: `RAM SPEED MISMATCH \n your computer will run at ${parseInt(state.menuOptions.cpu.item.contents.compat.ram_speed)} Mhz`})
                                                    }
                                                }
                                                else{
                                                    commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: true, warning: true, message: `RAM SPEED MISMATCH \n your computer will run at ${parseInt(item.compat.ram_speed) < parseInt(buildItem.item.contents.compat.ram_speed) ? parseInt(item.compat.ram_speed) : parseInt(buildItem.item.contents.compat.ram_speed)} Mhz`})
                                                }
                                            }
                                            // else {
                                            //     commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: false, message: 'motherboard ram speed ' + buildItem.item.contents.compat.ram_speed + ' is incompatible with' + item.compat.ram_speed + ' speed ram'})
                                            // }
                                        }
                                        break
                                    case 'ram_slots':
                                        if (state.menuOptions.ram.item.contents && buildItem){
                                            var totalSticks = 0
                                            if(state.menuOptions.ram.item.contents && state.menuOptions.ram.item.contents.length >0){
                                                for(var j = 0; j < state.menuOptions.ram.item.contents.length; j++){
                                                    totalSticks += parseInt(state.menuOptions.ram.item.contents[j].compat.number_of_items)
                                                }
                                            }
                                            if(totalSticks <= parseInt(buildItem.item.contents.compat.ram_slots)){
                                                commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: true, message: ''})
                                            }
                                            else {
                                                commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: false, message: 'number of ram sticks ' + totalSticks + ' is more than ' + buildItem.item.contents.compat.ram_slots + ' slots on the motherboard'})
                                            }
                                        }
                                        break
                                }
                                break
                        }    
                        break
                    // Storage          Compatibility Check
                    case 'storage':
                        switch (withType){                          // <<<<<<<<<< WITH THIS
                            case 'motherboard':
                                switch (option){
                                    case 'interface':
                                        if (buildItem){
                                            if(item.compat.compat_interface.toLowerCase().includes('sata')){
                                                if(buildItem.item.contents && parseInt(buildItem.item.contents.compat.sata_slots) > 0){
                                                    commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: true, message: ''})
                                                }
                                                else {
                                                    commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: false, message: 'motherboard does not have compatible interface'})
                                                }
                                            }
                                            if(item.compat.compat_interface.toLowerCase().includes('pci')){
                                                if(buildItem.item.contents && buildItem.item.contents.compat.nvme && buildItem.item.contents.compat.nvme !== '' && buildItem.item.contents.compat.nvme.toLowerCase() !== 'no' && buildItem.item.contents.compat.nvme.toLowerCase() !== 'n/a'){
                                                    commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: true, message: ''})
                                                }
                                                else {
                                                    commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: false, message: 'motherboard does not have compatible interface'})
                                                }
                                            }
                                        }
                                        break
                                    case 'sata':
                                        if (buildItem && item.compat.compat_interface.toLowerCase().includes('sata')){
                                            if(parseInt(buildItem.item.contents.compat.sata_slots) >1){
                                                commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: true, message: ''})
                                            }
                                            else {
                                                commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: false, message: 'motherboard does not have compatible interface'})
                                            }
                                        }
                                        break
                                    case 'sata_slots':
                                        if (state.menuOptions.storage.item.contents && buildItem){
                                            var totalSlots = 0
                                            if(state.menuOptions.storage.item.contents && state.menuOptions.storage.item.contents.filter((item) => item.compat.compat_interface.toLowerCase().includes('sata')).length <= parseInt(buildItem.item.contents.compat.sata_slots)){
                                                commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: true, message: ''})
                                            }
                                            else {
                                                commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: false, message: 'number of sata devices ' + totalSlots + ' is more than ' + buildItem.item.contents.compat.sata_slots + ' on the motherboard'})
                                            }
                                        }
                                        break
                                    case 'm.2_slots':
                                        if (state.menuOptions.storage.item.contents && buildItem){
                                            var totalSlots = 0
                                            if(state.menuOptions.storage.item.contents.filter((item) => item.compat.size.toLowerCase().includes('m.2')).length <= parseInt(buildItem.item.contents.compat.M_2_Slot)){
                                                commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: true, message: ''})
                                            }
                                            else {
                                                commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: false, message: 'number of m.2 devices ' + totalSlots + ' is more than ' + buildItem.item.contents.compat.M_2_Slot + ' slots on the motherboard'})
                                            }
                                        }
                                        break
                                }
                                break
                        }    
                        break
                    // Graphics         Compatibility Check
                    case 'graphics' || 'gpu':
                        switch (withType){                          // <<<<<<<<<< WITH THIS
                            case 'motherboard':
                                switch(option){
                                    case 'pci_e_x16':
                                        if (state.menuOptions.motherboard.item.contents && buildItem){
                                            var portsAvail = parseInt(buildItem.item.contents.compat.pci_e_x16)
                                            var portsOccupied = 0
                                            if(state.menuOptions.graphics.item.contents && state.menuOptions.graphics.item.contents.length >0){
                                                for(var j = 0; j < state.menuOptions.graphics.item.contents.length; j++){
                                                    portsOccupied++
                                                }
                                            }
                                            if(state.menuOptions.graphics.item.contents && portsOccupied <= portsAvail && portsOccupied !==0){
                                                commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: true, message: '', total: portsAvail})
                                            }
                                            else if (state.menuOptions.graphics.item.contents && portsOccupied > portsAvail){
                                                commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: false, total: portsAvail, message: 'number of PCI-E devices ' + portsOccupied + ' is more than ' +portsAvail + ' slots on the motherboard'})
                                            }
                                        }
                                        break
                                }
                                break
                        }    
                        break
                    // Power Supply Compatibility Check
                    case 'psu':
                        switch (withType){                          // <<<<<<<<<< WITH THIS
                            case 'general':
                                var itemWattage = parseFloat(item.specs.wattage)
                                function buildWattage(){ return state.buildTDP}
                                if(buildWattage() >0 && (itemWattage*0.8 > buildWattage())){
                                    commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: 'power', value: true, message: ''})
                                }
                                else if ((buildWattage() >0) && ((itemWattage*0.8) <= buildWattage())){
                                    commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: 'power', value: false, message: itemWattage+' psu does not have enough wattage to power your build' + buildWattage()})
                                }
                                break
                            case 'motherboard':
                                switch(option){
                                    case 'form_factor':
                                        var itemCompat      = item.compat.form_factor;
                                        var buildItemCompat = buildItem.item.contents.compat['form_factor'];
                                        if(buildItemCompat.toLowerCase().split('').filter((item) => item !== ' ' && item !== '-').join('').includes(itemCompat.toLowerCase())){
                                            commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: 'form_factor', value: true, message: ''})
                                        }
                                        else if (itemCompat !== buildItemCompat){
                                            commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: 'form_factor', value: false, message: itemCompat +' psu does not fit into your ' + buildItemCompat + ' build'})
                                        }
                                }
                                break
                            case 'case':
                                switch(option){
                                    case 'form_factor':
                                        var itemCompat      = item.compat.form_factor;
                                        var buildItemCompat = buildItem.item.contents.compat['form_factor'];
                                        if(itemCompat == buildItemCompat){
                                            commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: 'form_factor', value: true, message: ''})
                                        }
                                        else if (itemCompat !== buildItemCompat){
                                            commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: 'form_factor', value: false, message: itemCompat +' psu does not fit into your ' + buildItemCompat + ' build'})
                                        }
                                }
                                break
                        }
                        break
                    // Case Compatibility Check
                    case 'case':
                        switch (withType){                          // <<<<<<<<<< WITH THIS
                            case 'cpu':
                                break
                            case 'motherboard':
                                switch(option){
                                    case 'form_factor':
                                        var itemCompat      = item.compat.form_factor;
                                        var buildItemCompat = buildItem.item.contents.compat['form_factor'];
                                        if(itemCompat == buildItemCompat){
                                            commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: 'form_factor', value: true, message: ''})
                                        }
                                        else if(
                                            (itemCompat.toLowerCase().split('')         .filter((item) => item !== ' ' && item !=='-').join('') == 'atx'
                                            && buildItemCompat.toLowerCase().split('')  .filter((item) => item !== ' ' && item !=='-').join('') == 'microatx')
                                            || 
                                            (itemCompat.toLowerCase().split('')         .filter((item) => item !== ' ' && item !=='-').join('') == 'atx'
                                            && buildItemCompat.toLowerCase().split('')  .filter((item) => item !== ' ' && item !=='-').join('') == 'miniitx')
                                            || (itemCompat.toLowerCase().split('')      .filter((item) => item !== ' ' && item !=='-').join('') == 'atx'
                                            && buildItemCompat.toLowerCase().split('')  .filter((item) => item !== ' ' && item !=='-').join('') == 'nanoitx')
                                            || (itemCompat.toLowerCase().split('')      .filter((item) => item !== ' ' && item !=='-').join('') == 'microatx'
                                            && buildItemCompat.toLowerCase().split('')  .filter((item) => item !== ' ' && item !=='-').join('') == 'miniitx')
                                            || (itemCompat.toLowerCase().split('')      .filter((item) => item !== ' ' && item !=='-').join('') == 'miniatx'
                                            && buildItemCompat.toLowerCase().split('')  .filter((item) => item !== ' ' && item !=='-').join('') == 'microatx')
                                        ){
                                            commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: true, warning: true, message: 'Your '+ itemCompat +' case is bigger than ' + buildItemCompat + ' motherboard'})
                                        }
                                        else if(
                                            (itemCompat.toLowerCase().split('')         .filter((item) => item !== ' ' && item !=='-').join('') == 'microatx'
                                            && buildItemCompat.toLowerCase().split('')  .filter((item) => item !== ' ' && item !=='-').join('') == 'atx')
                                            || 
                                            (itemCompat.toLowerCase().split('')         .filter((item) => item !== ' ' && item !=='-').join('') == 'miniitx'
                                            && buildItemCompat.toLowerCase().split('')  .filter((item) => item !== ' ' && item !=='-').join('') == 'atx')

                                            || (itemCompat.toLowerCase().split('')      .filter((item) => item !== ' ' && item !=='-').join('') == 'nanoitx'
                                            && buildItemCompat.toLowerCase().split('')  .filter((item) => item !== ' ' && item !=='-').join('') == 'atx')

                                            || (itemCompat.toLowerCase().split('')      .filter((item) => item !== ' ' && item !=='-').join('') == 'miniitx'
                                            && buildItemCompat.toLowerCase().split('')  .filter((item) => item !== ' ' && item !=='-').join('') == 'microatx')

                                            || (itemCompat.toLowerCase().split('')      .filter((item) => item !== ' ' && item !=='-').join('') == 'nanoitx'
                                            && buildItemCompat.toLowerCase().split('')  .filter((item) => item !== ' ' && item !=='-').join('') == 'microatx')
                                            || (itemCompat.toLowerCase().split('')      .filter((item) => item !== ' ' && item !=='-').join('') == 'nanoitx'
                                            && buildItemCompat.toLowerCase().split('')  .filter((item) => item !== ' ' && item !=='-').join('') == 'miniitx')
                                        ){
                                            commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: option, value: false, message: 'Your ' + buildItemCompat + '  case is too small for this motherboard ' + itemCompat + ' size'})
                                        }
                                        else if (itemCompat !== buildItemCompat){
                                            commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: 'form_factor', value: false, message: itemCompat +' case does not fit into your ' + buildItemCompat + ' build'})
                                        }
                                }
                                break
                            case 'psu':
                                switch(option){
                                    case 'form_factor':
                                        var itemCompat      = item.compat.form_factor;
                                        var buildItemCompat = buildItem.item.contents.compat['form_factor'];
                                        if(itemCompat == buildItemCompat){
                                            commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: 'form_factor', value: true, message: ''})
                                        }
                                        else if (itemCompat !== buildItemCompat){
                                            commit(recordCompat, {type: item.type, asin: item.asin, withType: withType, option: 'form_factor', value: false, message: itemCompat +' case does not fit into your ' + buildItemCompat + ' build'})
                                        }
                                }
                                break
                        }    
                        break
                }
            }
        }
    },
    async addToBuild        ({ commit }, item){
        commit('newBuildItem', item);
        console.log('item', item.type, ' added to build')
    },
    async addToMenu         ({ commit }, item){
        commit('newMenuItem', item);
        store.dispatch('compatTableReset')
    },
    async getPrice          ({ commit }){
        console.log('get price initiated')
        commit('count')
        console.log('total cost commited')
    },
    async rmFromBuild       ({ commit }, {item, id}){
        commit('rmBuildItem', {item, id}); 
    },
    async rmFromMenu        ({ commit }, item){
        commit('rmMenuItem', item);
        store.dispatch('compatTableReset')
        console.log(item + ' removed from menu') 
    },
    async saveBuild         ({ commit }, {...data}){
        console.log(data)
        console.log('sending this: ', localStorage.usertoken)
        return await axios({
            url: `${SERVER_PATH}builds/add`,
            method: "post",
            headers: {
                'Content-Type': `application/json`,
                'Authorization': `Bearer ${localStorage.usertoken}`,
                'alg': "HS256",
                'typ': "JWT"
            },
            data: data
        })
        .then((response) => {
            console.log(JSON.stringify(response.data))
            if (JSON.stringify(response.data).includes('User id is empty')){
                store.dispatch('setError', 'User Id is Empty')
            }
            else if (JSON.stringify(response.data).includes('Added')){
                var message = ' was added to '
                console.log(message)
                store.dispatch('setBuildAdded', message)
            }
            else if (JSON.stringify(response.data).includes('ERROR' || 'error')){
                if (JSON.stringify(response.data).includes('sqlMessage')) {
                    store.dispatch('setError', response.data.sqlMessage)
                }
                else {
                    store.dispatch('setError', 'Unknown Error')
                }
            }
            console.log(response)
            return response
        })
        .catch((err) => {
            console.log('error!!!', err)
            store.dispatch('setError', JSON.stringify(err))
        })
    },
    async rmBuild           ({ commit }, build_id){
        commit('PROCESSING', true)
        console.log('removing build with id ', build_id)
        return await axios({
            url: `${SERVER_PATH}builds/?id=${build_id}`,
            method: "delete",
            headers: {
                'Content-Type': `application/json`,
                'Authorization': `Bearer ${localStorage.usertoken}`,
                'alg': "HS256",
                'typ': "JWT"
            },
        }).then(async (response)=>{
            store.dispatch('fetchUserBuilds', JSON.parse(localStorage.user).id)
            console.log(response)
            commit('PROCESSING', false)
        }).catch((err) => {
            commit('PROCESSING', false)
            console.log(err)
        })
    },
    loadBuild               ({commit}, build){
        console.log('loading build ', build)
        commit('RESET_BUILD')
        var fieldExceptions = [
            'name',
            'accessories',
            'image',
            'id',
            'author_id',
            'cost',
            'status'
          ]
        for (var prop in build){
            if(!fieldExceptions.includes(prop) && !prop.includes('_')){
                if(build[prop] !== null){
                    if(typeof(build[prop]) == 'object' && build[prop].length >=1){
                        for(var i = 0; i<build[prop].length; i++){
                            commit('newBuildItem', build[prop][i])
                            commit('newMenuItem', build[prop][i])
                        }
                    }
                    else {
                        commit('newBuildItem', build[prop])
                        commit('newMenuItem', build[prop])
                    }
               
                }
                console.log(prop, build[prop])
            }
        }
        console.log('loading build: ', build)
        store.dispatch('compatTableReset')
        var startIndex = 0
        if(build['processor'] && build['processor'].id){
            startIndex = build['processor'].id
        }
        router.push({path: "/builder/cpu?id="+startIndex}).catch(()=>{})

        commit('count')
    },
    buildReset              ({commit}){
        commit('RESET_BUILD')
        store.dispatch('compatTableReset')
        commit('count')
    },
    compatTableReset    ({commit, state}){
        commit('RESET_COMPAT_TABLE')
        commit('RESET_COMPAT_LIB')
        store.commit('assigningItems', store.getters.getFetchedItems)
        functions.createCompatTable({build: state.menuOptions})
    },
    resetWarnings({commit}){
        commit('RESET_WARNINGS')
    },
    compatLibReset    ({commit, state}, item){
        commit('RESET_COMPAT_LIB')

    }
};

const mutations = {
    RESET_WARNINGS(state){
        state.warnings = []
    },
    UPDATE_BUILD_STATUS(state, status){
        state.buildStatus = status
    },
    SET_COMPAT_MODE(state, bool){
        state.compatibleMode = bool
    },
    RESET_COMPAT_TABLE  (state){
        state.stateCompatTable = {}
    },
    RESET_COMPAT_LIB  (state){
        state.compatLib = {}
    },
    BUILDS_LOADED       (state, bool){
        state.buildsLoaded = bool
    },
    RECORD_FETCHED_BUILDS(state, builds){     
        state.recentBuilds = [...builds]
    },
    RESET_BUILD         (state){
        console.log('build reset started, got menu: ', Object.keys(state.menuOptions), ' build: ', state.build)
        var keysArr = Object.keys(state.menuOptions)
        for(var i = 0; i< keysArr.length; i++){
            state.menuOptions[keysArr[i]].item.contents = null
            state.build[i].contents = null
        }
    },
    RECORD_STATE_COMPAT       (state, {type, withType, option, value, message, warning}){
        if(!state.stateCompatTable[type]){
            state.stateCompatTable[type] = {}
        }
        if(!state.stateCompatTable[type][withType]){
            state.stateCompatTable[type][withType] = {}
        }
        state.stateCompatTable[type][withType][option] = {
            compatible: value,
            message: message,
            warning: warning || ''
        }
        if(!state.warningsTable[type]){
            state.warningsTable[type] = {}
        }
        if(!state.warningsTable[type][withType]){
            state.warningsTable[type][withType] = {}
        }
        state.warningsTable[type][withType][option] = {
            message: message,
        }
        if(state.warnings && warning){
            if(state.warnings.length > 0 && !state.warnings.includes(message)){
                var tmp = [...state.warnings]
               
                tmp.push(message)
                state.warnings = [...tmp]
            }
            else if(!state.warnings.includes(message)) {var tmp = []; tmp.push(message); state.warnings = [...tmp]}
        }
    },
    RECORD_COMPAT       (state, {type, withType, option, value, message, warning}){
        if(!state.compatTable[type]){
            state.compatTable[type] = {}
        }
        if(!state.compatTable[type][withType]){
            state.compatTable[type][withType] = {}
        }
        state.compatTable[type][withType][option] = {
            compatible: value,
            message: message,
            warning: warning || ''
        }
    },
    RECORD_LIB_COMPAT   (state, {type, asin, withType, option, value, message, warning}){
        if(!state.compatLib[asin]){
            state.compatLib[asin] = {}
        }
        if(!state.compatLib[asin][type]){
            state.compatLib[asin][type] = {}
        }
        if(!state.compatLib[asin][type][withType]){
            state.compatLib[asin][type][withType] = {}
        }
        state.compatLib[asin][type][withType][option] = {
            compatible: value,
            message: message,
            warning: warning || ''
        }
    },
    PROCESSING          (state, bool){
        state.processing = bool
    },
    count               (state) {
       const localBuild = state.build
        //    console.log('counting build total price: ', localBuild)
       state.totalCost = 0
       var tdp = 0
        for (var i = 0; i < localBuild.length; i++){
            // console.log('looping ', i, ' through the build, ', localBuild[i])
            if (localBuild[i].contents !== null){
                // console.log('checking type ', localBuild[i].type)
                if(localBuild[i].type == 'ram'||localBuild[i].type == 'storage'||localBuild[i].type == 'gpu'|| localBuild[i].type == 'graphics'){
                    // console.log('caught array type ', localBuild[i].contents)
                    if(typeof(localBuild[i].contents) == 'object' && localBuild[i].contents.length >0){
                        // console.log('type ', localBuild[i].type, ' is not empty')
                        for(var j = 0; j< localBuild[i].contents.length; j++){
                            // console.log('counting array ', localBuild[i].contents[j])
                            state.totalCost += parseFloat(localBuild[i].contents[j].amzn_price)
                            if(localBuild[i].type == 'ram'){
                                tdp += 3*(parseInt(localBuild[i].contents[j].compat.capacity) / 8)
                            }
                            else{
                                tdp += parseInt(localBuild[i].contents[j].compat.tdp)
                            }
                        }
                    }
                }
                else {
                    // console.log('item with type ', state.build[i].contents.type, state.build[i].contents)
                    state.totalCost += parseFloat(localBuild[i].contents.amzn_price)
                    if(localBuild[i].type !== 'psu' && localBuild[i].type !== 'case'){
                        tdp += parseInt(localBuild[i].contents.compat.tdp)
                    }
                }
            }      
        }
        state.buildTDP = tdp
        EventBus.$emit("totalCostChanged", state.totalCost)
    },
    newBuildItem:       (state, item) => {
        // console.log('build received ',  item)
        var itemLocal = item
        var localtype = itemLocal.type

        for (var i =0; i<state.build.length; i++){
            // console.log('starting build loop', item.type, state.build[i].type)
            if (localtype == 'graphics'){
                localtype = 'gpu'
            }
            if (localtype == state.build[i].type){
                if(localtype == 'cpu'){
                    localtype = 'processor'
                }
                console.log('adding ', item.type, 'to build type: ',  state.build[i].type)
                if(localtype == 'ram' || localtype == 'storage' || localtype == 'gpu' || localtype == 'graphics'){
                    // console.log('type ', localtype, ' is associated with array...')
                    var itemsArr = []
                    var idsArr = []
                    console.log('contents: ', state.build[i].contents)
                    if(state.build[i].contents !== null && typeof(state.build[i].contents) == 'object' && state.build[i].contents.length >0){
                        console.log('contents is not empty, saving...')
                        itemsArr = [...state.build[i].contents]
                    }
                    itemsArr.push(item)
                    console.log('ITEM PUSHED ', state.build[i].type)
                    state.build[i].contents = itemsArr;
                    console.log('item ', item, ' is added to build\'s', state.build[i].type, ' build: ', state.build)
                    for(var i = 0; i< itemsArr.length; i++){
                        idsArr.push(itemsArr[i].id)
                        console.log('getting items\' id ', idsArr)
                    }
                    state.buildRaw[`${
                        localtype == 'gpu' ? 'graphics'
                        : localtype
                        }_id`] = JSON.stringify(idsArr)
                    console.log('id was added to buildRaw ', state.buildRaw)
                    return
                }
                else {
                    state.build[i].contents = itemLocal;
                    state.buildRaw[`${localtype == "cpu" ? 'processor' : localtype}_id`] = state.build[i].contents.id
                    console.log('item added to build ', state.build[i].type, ' and item id is added to build id list', state.buildRaw)
                    return
                }
            }
        }  
    },
    rmBuildItem:        (state, {item, id}) => {
        // console.log('build received ',  item)
        var localtype = item.type
        if (localtype == 'graphics'){
            localtype = 'gpu'
        }
        for (var i =0; i<state.build.length; i++){
            // console.log('starting build loop', localtype, state.build[i].type)
            if (localtype == state.build[i].type){
                if(localtype == 'ram' || localtype == 'storage' || localtype == 'gpu'){
                    var ids = []
                    if(typeof(state.build[i].contents) == 'object' && id !== undefined && state.build[i].contents.length > 0){
                        var itemsArr = [...state.build[i].contents]
                        for(var l = 0; l < itemsArr.length; l++){
                            if(itemsArr[l].id == id){
                                console.log('found match, removing')
                                itemsArr.splice(l, 1)
                                break
                            }
                        }
                        state.build[i].contents = itemsArr
                        for(var k = 0; k <state.build[i].contents.length; k++){
                            ids.push(state.build[i].contents[k].id)
                        }
                    }
                    else {
                        state.build[i].contents = null;
                        state.buildRaw[
                            `${
                                state.build[i].type == "cpu" ? 'processor'
                                : state.build[i].type == 'gpu' ? 'graphics'
                                : state.build[i].type
                                }_id`
                        ] = ids
                    }
                    console.log(item, ' item is removed from build') 
                }
                else {
                    state.buildRaw[
                        `${
                            state.build[i].type == "cpu" ? 'processor'
                            : state.build[i].type == 'gpu' ? 'graphics'
                            : state.build[i].type
                            }_id`
                    ] = ''
                    state.build[i].contents = null;
                    console.log(item, ' item is removed from build') 
                }
            }
        }  
    },
    newMenuItem:        (state, item) => {
        console.log('adding to menu')
        if(item.type == 'cpu'){
            state.menuOptions.cpu.item.contents = item
            console.log('item ', item, ' with type ', item.type, ' is added to menu ', state.menuOptions)
        }
        if(item.type == 'motherboard'){
            state.menuOptions.motherboard.item.contents = item
            console.log('item ', item, ' with type ', item.type, ' is added to menu ', state.menuOptions)
        }
        var arr
        if(item.type == 'ram'){
            console.log('recognized type : ', item.type)
            if(state.menuOptions.ram.item.contents !== null && state.menuOptions.ram.item.contents.length >0){
                console.log('saving state: ', [...state.menuOptions.ram.item.contents])
                arr = [...state.menuOptions.ram.item.contents]
                arr.push(item)
                state.menuOptions.ram.item.contents = arr
                console.log('state updated: ', state.menuOptions.ram.item.contents)
            }
            else {
                state.menuOptions.ram.item.contents = [{...item}]
                console.log('ram contents added to menu: ',  [{...item}])
            }
            // state.menuOptions.ram.item.contents = item
        }
        if(item.type == 'storage'){
            console.log('recognized type : ', item.type)
            if(state.menuOptions.storage.item.contents !== null && state.menuOptions.storage.item.contents.length >0){
                console.log('saving state: ', [...state.menuOptions.storage.item.contents])
                arr = [...state.menuOptions.storage.item.contents]
                arr.push(item)
                state.menuOptions.storage.item.contents = arr
                console.log('state updated: ', state.menuOptions.storage.item.contents)
            }
            else {
                state.menuOptions.storage.item.contents = [{...item}]
                console.log('storage contents added to menu: ',  [{...item}])
            }
        }
        if(item.type == 'gpu' || item.type == 'graphics'){
            console.log('recognized type : ', item.type)
            if(state.menuOptions.graphics.item.contents !== null && state.menuOptions.graphics.item.contents.length >0){
                console.log('saving state: ', [...state.menuOptions.graphics.item.contents])
                arr = [...state.menuOptions.graphics.item.contents]
                arr.push(item)
                state.menuOptions.graphics.item.contents = arr
                console.log('state updated: ', state.menuOptions.graphics.item.contents)
            }
            else {
                state.menuOptions.graphics.item.contents = [{...item}]
                console.log('graphics contents added to menu: ',  [{...item}])
            }
        }
        if(item.type == 'psu'){
            state.menuOptions.psu.item.contents = item
            console.log('item ', item, ' with type ', item.type, ' is added to menu ', state.menuOptions)
        }
        if(item.type == 'case'){
            state.menuOptions.case.item.contents = item
            console.log('item ', item, ' with type ', item.type, ' is added to menu ', state.menuOptions)
        }
        if(item.type == 'accessories'){
            state.menuOptions.accessories.item.contents = item
        }
    },
    rmMenuItem:         (state, {item, id}) => {
        if(item.type == 'cpu'){
            state.menuOptions.cpu.item.contents = null
        }
        if(item.type == 'motherboard'){
            state.menuOptions.motherboard.item.contents = null
        }
        var itemsArr
        if(item.type == 'ram'){
            if(state.menuOptions.ram.item.contents !== null && id !==undefined && typeof(state.menuOptions.ram.item.contents) == 'object' && state.menuOptions.ram.item.contents.length > 0){
                itemsArr = [...state.menuOptions.ram.item.contents]
                for(var l = 0; l < itemsArr.length; l++){
                    if(itemsArr[l].id == id){
                        console.log('found match, removing')
                        itemsArr.splice(l, 1)
                        break
                    }
                }
                state.menuOptions.ram.item.contents = itemsArr
                if(state.menuOptions.ram.item.contents.length == 0){
                    state.menuOptions.ram.item.contents = null
                }
            }
            else {
                state.menuOptions.ram.item.contents = null
            }
        }
        if(item.type == 'storage'){
            if(state.menuOptions.storage.item.contents !== null && id !==undefined && typeof(state.menuOptions.storage.item.contents) == 'object' && state.menuOptions.storage.item.contents.length > 0){
                itemsArr = [...state.menuOptions.storage.item.contents]
                for(var m = 0; m < itemsArr.length; m++){
                    if(itemsArr[m].id == id){
                        console.log('found match, removing')
                        itemsArr.splice(m, 1)
                        break
                    }
                }
                state.menuOptions.storage.item.contents = itemsArr
                if(state.menuOptions.storage.item.contents.length == 0){
                    state.menuOptions.storage.item.contents = null
                }
            }
            else {
                state.menuOptions.storage.item.contents = null
            }
        }
        if(item.type == 'gpu' || item.type == 'graphics'){
            if(state.menuOptions.graphics.item.contents !== null && id !==undefined && typeof(state.menuOptions.graphics.item.contents) == 'object' && state.menuOptions.graphics.item.contents.length > 0){
                itemsArr = [...state.menuOptions.graphics.item.contents]
                for(var n = 0; n < itemsArr.length; n++){
                    if(itemsArr[n].id == id){
                        console.log('found match, removing')
                        itemsArr.splice(n, 1)
                        break
                    }
                }
                state.menuOptions.graphics.item.contents = itemsArr
                if(state.menuOptions.graphics.item.contents.length == 0){
                    state.menuOptions.graphics.item.contents = null
                }
            }
            else {
                state.menuOptions.graphics.item.contents = null
            }
        }
        if(item.type == 'psu'){
            state.menuOptions.psu.item.contents = null
        }
        if(item.type == 'case'){
            state.menuOptions.case.item.contents = null
        }
        if(item.type == 'accessories'){
            state.menuOptions.accessories.item.contents = []
        }
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}